<template>
  <div class="content">
    <div class="albums"><AlbumListContainer /></div>
    <div class="albums-mobile">
      <div class="tab">
        <input id="album-expand" type="checkbox" name="tabs">
        <label for="album-expand">Album List</label>
        <div class="tab-content">
          <div>
            <AlbumListContainer />
          </div>
        </div>
      </div>
    </div>
    <div class="album-edit"><AlbumEditContainer :route="$route" :id="id" /></div>
  </div>
</template>

<script>
import AlbumListContainer from './AlbumListContainer'
import AlbumEditContainer from './AlbumEditContainer'
export default {
  props: ['id'],
  components: {
    AlbumListContainer,
    AlbumEditContainer
  },
}
</script>

<style lang="stylus" scoped>
.content
  display flex

  @media only screen and (max-width: 639px)
    flex-direction column

  .albums
    padding 0 30px 30px 30px
    min-width 260px
    max-width 260px
    border-right 1px solid #cccccc

    @media only screen and (max-width: 639px)
      visibility hidden
      display none

  .album-edit
    flex 1
    padding 0 30px 30px 30px

.albums-mobile
  color white

  @media only screen and (min-width: 640px)
    visibility hidden
    display none


.tab
  position relative
  margin-bottom 1px
  width 100%

  label
    position relative
    display block
    padding 10px 30px
    background #189ea6
    cursor pointer
    color #fff

input
  position absolute
  opacity 0
  z-index -1

.tab-content
  max-height 0
  overflow hidden
  background #189ea6
  -webkit-transition max-height .35s
  -o-transition max-height .35s
  transition max-height .35s

  div
    margin 1em

input:checked ~ .tab-content
  max-height 100%
  padding-bottom 20px
</style>
